export enum GenderEnum {
  Unknown = 0,
  Male = 1,
  Female = 2,
}

export type GenderCode = 0 | 1 | 2;

const GENDER_TEXT: Record<GenderCode, string> = {
  [GenderEnum.Male]: '男',
  [GenderEnum.Female]: '女',
  [GenderEnum.Unknown]: '未知',
};

export function genderCodeToText(code: unknown): number {
  const n = Number(code);
  if (n === GenderEnum.Unknown) return 0;
  if (n === GenderEnum.Male) return 1;
  if (n === GenderEnum.Female) return 2;
  return 0;
}

export function genderDisplayText(input: unknown, fallback = ''): string {
  const raw = String(input ?? '').trim();
  if (!raw) return fallback;

  if (raw === '男' || raw.toUpperCase() === 'M' || raw.toUpperCase() === 'MALE') {
    return GENDER_TEXT[GenderEnum.Male];
  }

  if (raw === '女' || raw.toUpperCase() === 'F' || raw.toUpperCase() === 'FEMALE') {
    return GENDER_TEXT[GenderEnum.Female];
  }

  if (raw === '未知' || raw.toLowerCase() === 'unknown') {
    return GENDER_TEXT[GenderEnum.Unknown];
  }

  const code = Number(raw);
  if (code === GenderEnum.Male || code === GenderEnum.Female || code === GenderEnum.Unknown) {
    return GENDER_TEXT[code];
  }

  return raw;
}

export function genderTextToCode(input: unknown): GenderCode {
  const s = String(input ?? '').trim();
  const upper = s.toUpperCase();
  if (!s) return GenderEnum.Unknown;
  if (s === '0' || upper === 'UNKNOWN' || s.includes('未知')) return GenderEnum.Unknown;
  if (s === '1' || s === '男' || upper === 'M' || upper === 'MALE') return GenderEnum.Male;
  if (s === '2' || s === '女' || upper === 'F' || upper === 'FEMALE') return GenderEnum.Female;
  return GenderEnum.Unknown;
}

export function dicomPatientSexToCode(input: unknown): GenderCode {
  const s = String(input ?? '').trim().toUpperCase();
  if (!s) return GenderEnum.Unknown;
  if (s === 'M' || s === 'MALE' || s.includes('男')) return GenderEnum.Male;
  if (s === 'F' || s === 'FEMALE' || s === 'W' || s === 'WOMAN' || s.includes('女')) return GenderEnum.Female;
  return GenderEnum.Unknown;
}
